import { useEffect, useRef, useState } from 'react';
import { formatExact } from './MoneyText.js';

/**
 * The hero number counts up to its value on arrival — 500ms, ease-out,
 * starting from 96% so the motion reads as settling, never as a slot machine.
 * Reduced-motion readers get the final figure immediately.
 */
export function CountUp({ paise }: { paise: number }) {
  const [shown, setShown] = useState(paise);
  const raf = useRef(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setShown(paise);
      return;
    }
    const from = paise * 0.96;
    const t0 = performance.now();
    const tick = (t: number) => {
      const k = Math.min(1, (t - t0) / 500);
      const ease = 1 - (1 - k) ** 3;
      setShown(Math.round(from + (paise - from) * ease));
      if (k < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [paise]);

  return <>{formatExact(shown)}</>;
}
